import { FC } from 'react';
import Tooltip from '../Tooltip';
import IconButton from '../IconButton';
import Star from 'assets/vectors/star.svg';
import StarInactive from 'assets/vectors/star-inactive.svg';

type Props = {
  text: string;
  active: boolean;
  onClick?: (e: any) => void;
};

const StarButton: FC<Props> = ({ active, text, onClick }) => {
  const starIcon = active ? Star : StarInactive;
  return (
    <Tooltip paragraph={text} position="left">
      <IconButton onClick={onClick} data-testid="favorite">
        <img src={starIcon} alt="star" />
      </IconButton>
    </Tooltip>
  );
};

export default StarButton;
